import { ApiPath } from "enums";
import { Post } from "utils";

export const uploadFileApi = async (query) => {
  const res = await Post(ApiPath.Storage, query?.body);
  return res.data;
};
